"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/toggle-on.svg.js",
    _defs,
    _path,
    _g;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 31,
    height: 18,
    viewBox: "0 0 31 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  }, React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "99.021%",
    id: "prefix__a",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: this
  }, React.createElement("stop", {
    stopOpacity: 0,
    offset: "0%",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: this
  }), React.createElement("stop", {
    stopOpacity: 0.02,
    offset: "80%",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: this
  }), React.createElement("stop", {
    stopOpacity: 0.04,
    offset: "100%",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    },
    __self: this
  })), React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "prefix__b",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: this
  }, React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.12,
    offset: "0%",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  }), React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.06,
    offset: "20%",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    },
    __self: this
  }), React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: this
  })))), _path || (_path = React.createElement("path", {
    opacity: 0.5,
    d: "M28.525 9c0 3.25-2.557 5.833-5.775 5.833H6.25C3.033 14.833.475 12.25.475 9S3.033 3.167 6.25 3.167h16.5c3.218 0 5.775 2.583 5.775 5.833z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    },
    __self: this
  })), _g || (_g = React.createElement("g", {
    strokeWidth: 0.5,
    transform: "translate(.475 .667)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22
    },
    __self: this
  }, React.createElement("ellipse", {
    stroke: "url(#prefix__a)",
    cx: 22.275,
    cy: 8.333,
    rx: 8,
    ry: 8.083,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23
    },
    __self: this
  }), React.createElement("ellipse", {
    stroke: "url(#prefix__b)",
    cx: 22.275,
    cy: 8.333,
    rx: 8,
    ry: 8.083,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24
    },
    __self: this
  }))));
}

var _default = ReactComponent;
exports["default"] = _default;